/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Knowit
// License: CC-BY 4.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const SearchContent = (props: Props): JSX.Element => (
  <Icon viewBox="0 0 53.1 40" {...props}>
    <path d="M52.2 5.3h-3.5V1.8a.9.9 0 0 0-.9-.9S38.9 0 34.5 0a43 43 0 0 0-8 .8 42 42 0 0 0-7.9-.8C14.2 0 5.3.9 5.3.9s-.8.4-.9.9v3.5H.9c-.5.1-.9.4-.9.9v32.9a.9.9 0 0 0 .9.9h51.3a.9.9 0 0 0 .9-.9V6.2c0-.5-.4-.8-.9-.9M34.5 1.8a85 85 0 0 1 12.4.9v31.1s-8.8-.9-12.4-.9a43 43 0 0 0-7.1.9v-7.2a11 11 0 0 0 4.4-1.8l7.5 5.6a2.3 2.3 0 0 0 1.8.5 2.6 2.6 0 0 0 1.6-.9l.5-.7a2.4 2.4 0 0 0-.4-3.3l-7.5-5.6a11 11 0 0 0 .8-3.3 10.3 10.3 0 0 0-8.7-10.7V2.7s.9-.9 7.1-.9M26.4 8a8.6 8.6 0 0 1 4.7 1.9 8.2 8.2 0 0 1 3.2 7.1 8.4 8.4 0 0 1-13.6 6.1 8.3 8.3 0 0 1-3.2-7.1 8.5 8.5 0 0 1 8.9-8m8.1 14 7.2 5.4a.6.6 0 0 1 .1.9l-.5.6c-.1.2-.3.2-.4.3l-.5-.2-7.2-5.4a10 10 0 0 0 1.3-1.6M6.2 2.7a85 85 0 0 1 12.4-.9c6.2 0 7.1.9 7.1.9v3.6a10.2 10.2 0 0 0-6.6 2.5 10.6 10.6 0 0 0-3.4 7.1 10.3 10.3 0 0 0 3.9 8.6 10.5 10.5 0 0 0 5.7 2.2h.4v7.1a43 43 0 0 0-7.1-.9c-3.6 0-12.4.9-12.4.9Zm45.1 35.5H1.8V7.1h2.6v27.5a.9.9 0 0 0 .9.9s9.7-.9 13.3-.9a49 49 0 0 1 7.6.9h.6a51 51 0 0 1 7.7-.9c3.6 0 13.3.9 13.3.9a1.1 1.1 0 0 0 .9-.9V7.1h2.6Z" />
  </Icon>
);
